module.exports = __webpack_public_path__ + "img/3.653260bd.jpg";